/**
 * The country/campaign override tables under a COMPARE-mode condition — the
 * same tables ConditionRow renders in value mode: the comparison is the
 * default, and each override row independently pins a fixed number or
 * carries its own comparison for that scope.
 * For Media Devoted | Created By Ciro Autiero
 */

import { type FC } from 'react';
import type { TagCampaignThreshold, TagCountryThreshold } from '@trafficpulse/shared';

import { CampaignThresholdOverrides } from '@/pages/admin/ListTagRulesPage/components/rule-condition/campaign-overrides';
import { CountryThresholdOverrides } from '@/pages/admin/ListTagRulesPage/components/rule-condition/country-overrides';

export interface CompareOverrideTablesProps {
  countryThresholds?: TagCountryThreshold[];
  campaignThresholds?: TagCampaignThreshold[];
  onCountryChange: (rows: TagCountryThreshold[]) => void;
  onCampaignChange: (rows: TagCampaignThreshold[]) => void;
  fields?: ReadonlyArray<{ key: string; label: string }>;
}

export const CompareOverrideTables: FC<CompareOverrideTablesProps> = ({
  countryThresholds,
  campaignThresholds,
  onCountryChange,
  onCampaignChange,
  fields,
}) => (
  <div className="mt-3 overflow-hidden rounded-lg border border-border bg-muted/20">
    <CountryThresholdOverrides
      rows={countryThresholds ?? []}
      onChange={onCountryChange}
      fields={fields}
    />
    <CampaignThresholdOverrides
      rows={campaignThresholds ?? []}
      onChange={onCampaignChange}
      fields={fields}
    />
  </div>
);

export default CompareOverrideTables;
